<template>
  <div class="opera-btn-group " :class="{up:!showSearch}">
    <div class="opera-icon">
          <span class="pull-right">
            <des-btn custom icon="plus" perm="report-confirm-query" @click="addAdjust">添加</des-btn>
          </span>
    </div>
    <el-form class="advanced-query-form" onsubmit="return false">
      <el-row>
        <el-col :span="8">
          <oms-form-row :span="6" label="货品主档">
            <goods-select :remote-method="queryManageGoods" placeholder="请输入名称搜索货品主档"
                          v-model="searchCondition.goodsId" :list="dhsGoodsList"></goods-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="批号" :span="5">
            <el-select v-model="searchCondition.batchNumberId" filterable clearable remote
                       :remoteMethod="queryDhsBatchNumbers" placeholder="请输入批号名称搜索批号">
              <el-option v-for="item in batchNumberList" :value="item.id" :key="item.id" :label="item.batchNumber">
                {{ item.batchNumber }}
              </el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="" :span="3">
            <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
            <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
          </oms-form-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    props: {
      bizInTypes: Array,
      orgType: Object,
      activeStatus: [String, Boolean]
    },
    mixins: [MethodsMix],
    data() {
      return {
        showSearch: true,
        searchCondition: {
          goodsId: '',
          batchNumberId: '',
          supplyManufacturersId: '',
          nearTermDays: '',
          logisticsCentreId: ''
        }
      };
    },
    computed: {
      role() {
        return this.$route.meta.role;
      }
    },
    watch: {
      role() {
        this.resetSearchForm();
      }
    },
    methods: {
      queryDhsBatchNumbers(val) {
        if (!this.searchCondition.goodsId) {
          this.batchNumberList = [];
          this.$notify.info('请选择货品主档');
          return;
        }
        this.queryDhsBatchNumberList({
          keyWord: val,
          goodsId: this.searchCondition.goodsId
        });
      },
      searchInOrder: function () {// 搜索
        this.$emit('search', this.searchCondition);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          goodsId: '',
          batchNumberId: '',
          supplyManufacturersId: '',
          nearTermDays: '',
          logisticsCentreId: ''
        };
        Object.assign(this.searchCondition, temp);
        this.$emit('search', temp);
      },
      addAdjust() {
        this.$emit('add');
      }
    }
  };
</script>
